jQuery(document).ready(function($) {
    
    // mobile menu
    $('.mobile-menu-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('opened');
        $('.mobile-menu-panel').toggleClass('opened');
    }); 

    $('.mobile-menu-toggle-close').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('opened');
        $('.mobile-menu-panel').toggleClass('opened');
    }); 
});